import { render } from "./ReportManage.vue?vue&type=template&id=35dea94c"
import script from "./ReportManage.vue?vue&type=script&lang=js"
export * from "./ReportManage.vue?vue&type=script&lang=js"

import "./ReportManage.vue?vue&type=style&index=0&id=35dea94c&lang=less"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__